const CONSENT_KEY = 'bb_cookie_consent';

/**
 * @typedef {{ necessary: true, analytics: boolean, support: boolean, timestamp: string }} ConsentPrefs
 */

/** @returns {ConsentPrefs | null} */
export const getConsent = () => {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch {
    return null;
  }
};

/**
 * @param {{ analytics: boolean, support: boolean }} prefs
 * @returns {ConsentPrefs}
 */
export const setConsent = (prefs) => {
  const consent = {
    necessary: true,
    analytics: prefs.analytics ?? false,
    support: prefs.support ?? false,
    timestamp: new Date().toISOString(),
  };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  return consent;
};

/** @returns {boolean} */
export const hasConsented = () => getConsent() !== null;

export const resetConsent = () => {
  localStorage.removeItem(CONSENT_KEY);
};
